import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';

export const About = () => {
  const navigate = useNavigate();

  return (
    <div className="grain-overlay" data-testid="about-page">
      {/* Hero */}
      <section className="py-24 px-6 lg:px-12 bg-purple-100 text-purple-900">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-xs font-mono uppercase tracking-[0.3em] mb-6 text-purple-600">
            Our Story
          </p>
          <h1 className="text-5xl md:text-6xl font-heading font-light mb-8">
            20 Years of Innovation
          </h1>
          <p className="text-xl leading-relaxed text-purple-700">
            A groundbreaking scientific journey to revolutionize healing through the power of oyster shell technology.
          </p>
        </div>
      </section>

      {/* Story */}
      <section className="py-24 px-6 lg:px-12 bg-purple-25">
        <div className="max-w-4xl mx-auto">
          <div className="prose prose-lg max-w-none">
            <h2 className="text-3xl font-heading font-light mb-6">The Vision</h2>
            <p className="text-stone-600 leading-relaxed mb-8">
              A visionary approach to healing led to embarking on a 20-year journey that revolutionized
              the way we heal our bodies...forever. With unwavering dedication to scientific excellence and
              natural healing, our research team discovered the untapped potential of oyster shell calcium.
            </p>

            <h2 className="text-3xl font-heading font-light mb-6 mt-12">The Breakthrough</h2>
            <p className="text-stone-600 leading-relaxed mb-8">
              The SAC® formulation technology represents the world's first safe calcium ion delivery system.
              This revolutionary approach helps the body replenish and restore its calcium reserves while
              simultaneously detoxifying from harmful substances and pathogens.
            </p>

            <h2 className="text-3xl font-heading font-light mb-6 mt-12">Our Manufacturing Process</h2>
            <p className="text-stone-600 leading-relaxed mb-8">
              Our ingredients undergo a severe exclusive hot and cold manufacturing process designed to
              destroy heavy metals, toxins, and impurities often found in other products and even food.
              This rigorous process ensures the highest purity and effectiveness of our formulations.
            </p>

            <h2 className="text-3xl font-heading font-light mb-6 mt-12">Creating a Better Future</h2>
            <p className="text-stone-600 leading-relaxed mb-8">
              Today, Healer Marah continues this mission of creating a better future for all through
              pure, safe, and effective healing products. Each product represents years of research,
              development, and a commitment to excellence in natural healing.
            </p>
          </div>

          <div className="text-center mt-12">
            <Button
              size="lg"
              onClick={() => navigate('/shop')}
              className="rounded-full"
            >
              Explore Our Products
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
};